var exports = {
  "hl": "xcc377c0b--1c729a--address",
  "rl": "xcc377c0b--1c729a--address-fulladdress",
  "XY": "xcc377c0b--1c729a--address-underground",
};

module.exports = exports;
